import { z } from 'zod';

export const changePasswordSchema = z
  .object({
    currentPassword: z
      .string()
      .min(1, { message: 'Ingresá tu contraseña actual' }),
    newPassword: z
      .string()
      .min(6, { message: 'La contraseña debe tener al menos 6 caracteres' })
      .max(100, {
        message: 'La contraseña no puede tener más de 100 caracteres',
      }),
    confirmPassword: z
      .string()
      .min(1, { message: 'Debe confirmar la contraseña' }),
  })
  .refine((data) => data.newPassword !== data.currentPassword, {
    message: 'La nueva contraseña tiene que ser distinta de la actual',
    path: ['newPassword'],
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;
